module.exports = __webpack_public_path__ + "img/logo_zh.5b2bf73b.svg";